import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class LearningPathChapterLinkResponseDto {
  @ApiProperty({ type: 'string' })
  learningPathId!: string;

  @ApiProperty({ type: 'string' })
  chapterId!: string;

  @ApiProperty({ type: 'string' })
  addedByUserId!: string;

  @ApiProperty({ type: 'string', format: 'date-time' })
  createdAt!: Date;

  @ApiPropertyOptional({ description: 'Métadonnées chapitre (School API)', type: Object })
  chapter?: any;
}

